class DashBoard extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.dataTabs = this.querySelectorAll('[data-tab]');
        this.stockModal = this.querySelector('#stock-modal')
        this.specificationModal = this.querySelector("#specification-modal")
    }

    specifications(buttonContext) {
        if (buttonContext.classList.contains('active')) {
            return;
        }

        this.dataTabs.forEach(tab => {
            tab.classList.remove('active');
        });

        buttonContext.classList.add('active');
        const tabName = buttonContext.getAttribute('data-tab');
        const tabContent = this.querySelector(`[data-content="${tabName}"]`);
        if (tabContent) {
            this.querySelectorAll('[data-content]').forEach(content => {
                content.classList.remove('active');
            });
            tabContent.classList.add('active');
        }
    }

    education(buttonContext) {
        if (buttonContext.classList.contains('active')) {
            return;
        }

        this.dataTabs.forEach(tab => {
            tab.classList.remove('active');
        });

        buttonContext.classList.add('active');
        const tabName = buttonContext.getAttribute('data-tab');
        const tabContent = this.querySelector(`[data-content="${tabName}"]`);
        if (tabContent) {
            this.querySelectorAll('[data-content]').forEach(content => {
                content.classList.remove('active');
            });
            tabContent.classList.add('active');
        }
    }

    openStockModal(rowContext) {
        const productStock = rowContext.getAttribute('data-product-stock') === "true"
        if (!productStock) {
            const ATCButton = this.stockModal.querySelector('.AddToCart');
            ATCButton.setAttribute('disabled', true);
            ATCButton.querySelector('[atc-label]').textContent = "Out of Stock"
        }

        this.stockModal.querySelector('[data-image]').querySelector('img').src = `${Shopify.routes.root}cdn/shop/${rowContext.querySelector('[data-images]').getAttribute('featured-image')}`;
        this.stockModal.querySelector('[data-title]').textContent = rowContext.querySelector('[data-title]').textContent;
        this.stockModal.querySelector('[data-variant]').textContent = rowContext.querySelector('[data-variant]').textContent;
        this.stockModal.querySelector('[data-atc-variant-id]').setAttribute('data-atc-variant-id', rowContext.querySelector('[data-variant]').getAttribute('data-variant-id'))
        this.stockModal.querySelector('[data-cost]').textContent = rowContext.querySelector('[data-cost]').textContent;
        this.stockModal.querySelector('[data-stock]').textContent = rowContext.querySelector('[data-stock]').textContent;
    }

    openSpecificationModal(rowContext) {
        const productStock = rowContext.getAttribute('data-product-stock') === "true"
        if (!productStock) {
            const ATCButton = this.specificationModal.querySelector('.AddToCart');
            ATCButton.setAttribute('disabled', true);
            ATCButton.querySelector('[atc-label]').textContent = "Out of Stock"
        }

        this.specificationModal.querySelector('[data-image]').querySelector('img').src = `${Shopify.routes.root}cdn/shop/${rowContext.querySelector('[data-images]').getAttribute('featured-image')}`
        this.specificationModal.querySelector("[data-title]").textContent = rowContext.querySelector('[data-title]').textContent;
        this.specificationModal.querySelector("[data-colors]").textContent = rowContext.querySelector('[data-colors]').getAttribute('data-colors');
        this.specificationModal.querySelector("[data-sizes]").textContent = rowContext.querySelector('[data-sizes]').getAttribute('data-sizes');
        this.specificationModal.querySelector("[data-cost]").textContent = rowContext.querySelector('[data-cost]').textContent;
        this.specificationModal.querySelector('[data-atc-variant-id]').setAttribute('data-atc-variant-id', rowContext.querySelector('[data-variant-id]').getAttribute('data-variant-id'))
        this.specificationModal.querySelector("[data-description]").querySelector('[data-content]').textContent = rowContext.querySelector('[data-description]').getAttribute('data-description');
        this.specificationModal.querySelector("[data-materials]").querySelector('[data-content]').textContent = rowContext.querySelector('[data-materials]').textContent;
        this.specificationModal.querySelector("[data-care-instructions]").querySelector('[data-content]').textContent = rowContext.querySelector('[data-care-instructions]').textContent;
    }

    ATC(context) {
        context.classList.add('loading')
        context.setAttribute('disabled', true)
        const variantId = context.getAttribute('data-atc-variant-id');
        const quantity = context.getAttribute('data-atc-variant-quantity') ?? 1;

        const request = fetch(`${Shopify.routes.root}cart/add.js`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id: variantId,
                quantity,
                sections: [document.querySelector("cart-drawer").getAttribute("data-section-id")],
            })
        }).then(async (res) => {
            const data = await res.json();
            context.closest('cart-form').signalUpdate(data)
            context.closest('cart-form').config.responseHandlers.dataHandler(data)
            document.querySelector(context.getAttribute('data-modal-close')).click()
            context.classList.remove('loading')
            context.removeAttribute('disabled')
        })

    }

    stock(buttonContext) {
        if (buttonContext.classList.contains('active')) {
            return;
        }

        this.dataTabs.forEach(tab => {
            tab.classList.remove('active');
        });

        buttonContext.classList.add('active');
        const tabName = buttonContext.getAttribute('data-tab');
        const tabContent = this.querySelector(`[data-content="${tabName}"]`);
        if (tabContent) {
            this.querySelectorAll('[data-content]').forEach(content => {
                content.classList.remove('active');
            });
            tabContent.classList.add('active');
        }
    }

    instructions(buttonContext) {
        if (buttonContext.classList.contains('active')) {
            return;
        }

        this.dataTabs.forEach(tab => {
            tab.classList.remove('active');
        });

        buttonContext.classList.add('active');
        const tabName = buttonContext.getAttribute('data-tab');
        const tabContent = this.querySelector(`[data-content="${tabName}"]`);
        if (tabContent) {
            this.querySelectorAll('[data-content]').forEach(content => {
                content.classList.remove('active');
            });
            tabContent.classList.add('active');
        }
    }

    support(buttonContext) {
        if (buttonContext.classList.contains('active')) {
            return;
        }

        this.dataTabs.forEach(tab => {
            tab.classList.remove('active');
        });

        buttonContext.classList.add('active');
        const tabName = buttonContext.getAttribute('data-tab');
        const tabContent = this.querySelector(`[data-content="${tabName}"]`);
        if (tabContent) {
            this.querySelectorAll('[data-content]').forEach(content => {
                content.classList.remove('active');
            });
            tabContent.classList.add('active');
        }
    }

    eventRequests(buttonContext) {
        if (buttonContext.classList.contains('active')) {
            return;
        }

        this.dataTabs.forEach(tab => {
            tab.classList.remove('active');
        });

        buttonContext.classList.add('active');
        const tabName = buttonContext.getAttribute('data-tab');
        const tabContent = this.querySelector(`[data-content="${tabName}"]`);
        if (tabContent) {
            this.querySelectorAll('[data-content]').forEach(content => {
                content.classList.remove('active');
            });
            tabContent.classList.add('active');
        }
    }

    trainingRequests(buttonContext) {
        if (buttonContext.classList.contains('active')) {
            return;
        }

        this.dataTabs.forEach(tab => {
            tab.classList.remove('active');
        });

        buttonContext.classList.add('active');
        const tabName = buttonContext.getAttribute('data-tab');
        const tabContent = this.querySelector(`[data-content="${tabName}"]`);
        if (tabContent) {
            this.querySelectorAll('[data-content]').forEach(content => {
                content.classList.remove('active');
            });
            tabContent.classList.add('active');
        }
    }

    toggleSpecificationForm() {
        const form = this.querySelector('[data-content-form="specifications"]');
        if (form.classList.contains('active')) {
            this.querySelector('[data-content-root="specifications"]').classList.add('active');
        } else {
            this.querySelector('[data-content-root="specifications"]').classList.remove('active');
        }
        form.classList.toggle('active');
    }

    toggleStockForm() {
        const form = this.querySelector('[data-content-form="stock"]');
        if (form.classList.contains('active')) {
            this.querySelector('[data-content-root="stock"]').classList.add('active');
        } else {
            this.querySelector('[data-content-root="stock"]').classList.remove('active');
        }
        form.classList.toggle('active');
    }
}

customElements.define('dash-board', DashBoard);